export default __webpack_public_path__ + "static/media/info-rocket-ill.de578639.png";